export default function logError(e, context = {}) {
  console.error(e.toString());

  let errorId = null;
  if (window.Raven) {
    Raven.context(context, () => {
      Raven.captureException(e);
    });
    errorId = Raven.lastEventId();
    Raven.showReportDialog();
  }

  return errorId;
}



// WEBPACK FOOTER //
// ./src/lib/utils/errors/logError.js